<template>
  <div class="content">
    <h1 class="has-text-centered">Datenspeicherung</h1>
    <div class="box">
      <p>Eine kompakte Zusammenfassung über das sichere Speichern von Daten.</p>
      <FAQsTableOfContents :faqs="faqs" />
    </div>

    <div class="box">
      <FAQs :faqs="faqs" :h_level="2" />
    </div>

    <FeedbackBox />
  </div>
</template>

<script>
import FeedbackBox from '@/components/FeedbackBox.vue'
import FAQs from '@/components/FAQs.vue'
import FAQsTableOfContents from '@/components/FAQsTableOfContents.vue'

export default {
  name: 'theory-data-storage',
  components: {
    FeedbackBox,
    FAQs,
    FAQsTableOfContents
  },
  metaInfo: {
    title: 'Datenspeicherung | Elektrotechnik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Eine kompakte Zusammenfassung über das sichere Speichern von Daten.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'network-engineering' })
  },
  data () {
    return {
      faqs: [
        {
          question: 'Was sind allgemeine Tipps um Daten zu speichern?',
          answer:
            '<ul>' +
            '  <li>Strenge Zugangsrechte</li>' +
            '  <li>Im besten Fall hat der Datenspeicher keinen Zugang ins Internet</li>' +
            '  <ul>' +
            '    <li>Vorteil: Weniger potentielle Angreifer</li>' +
            '    <li>Nachteil: Starke Abstriche bei Funktionalität</li>' +
            '  </ul>' +
            '  <li>' +
            '    Bedenken dass Datenspeicher bisher NICHTlanglebig sind - eine regelmäßige Überprüfung auf Funktion ist notwendig' +
            '  </li>' +
            '</ul>'
        },
        {
          question: 'Was gibt es beim Speichern von Daten zu beachten?',
          answer:
            '<ul>' +
            '  <li><strong>Relevanz:</strong> Nur relevante Daten abspeichern - sorgt für geringe Datenmenge und erleichtert Backup sowie Verschlüsselungen</li>' +
            '  <li><strong>Redundanz:</strong> Mehrere Datenträger und/oder RAID-Systeme einsetzen</li>' +
            '  <li><strong>Migration:</strong> Regelmäßige Backups auf aktuelle Datenträger</li>' +
            '  <li><strong>Integrität:</strong> Regelmäßige Überprüfung der Datenträger</li>' +
            '  <li><strong>Qualität:</strong> Hochwertige Komponenten</li>' +
            '  <li><strong>Verschlüsselung:</strong></li>' +
            '  <ul>' +
            '    <li>Viele verschiedene Verschlüsselungsmethoden</li>' +
            '    <li>Open Source Software verfügbar</li>' +
            '    <li>Anwendbar auf einzelne Dateien oder ganze Ordner und Partitionen</li>' +
            '    <li>Beansprucht mehr Zeit</li>' +
            '    <li>Zugriff auf Daten wird dadurch umständlicher</li>' +
            '  </ul>' +
            '</ul>'
        },
        {
          question: 'Was gibt es bei Backups zu beachten?',
          answer:
            '<ul>' +
            '  <li>Regelmäßig durchgeführen</li>' +
            '  <li>Datenträger mit gesicherten Daten physisch getrennt vom Netzwerk aufbewahren</li>' +
            '  <li>Backup auf mehrere Datenträger</li>' +
            '</ul>' +
            '<h3>Was ist eine differentielle Datensicherung?</h3>' +
            '<ul>' +
            '  <li>Speichert nur Daten welche seit der letzten Komplettsicherung geändert oder hinzugefügt wurden</li>' +
            '  <li>Setzt immer auf letzter Komplettsicherung auf</li>' +
            '  <li>' +
            '    Speichert Zeit und Speicherplatz gegenüber Vollsicherung (Komplettsicherung' +
            '  </li>' +
            '</ul>' +
            '<h3>Was ist eine inkrementelle Datensicherung?</h3>' +
            '<ul>' +
            '  <li>Inkrementelle Sicherungen speichern Daten welche seit der letzten inkrementellen Sicherung verändert oder hinzugefügt wurden</li>' +
            '  <li>Bei Wiederherstellung müssen die Daten daher aus mehreren Sicherungen wiederhergestellt werden</li>' +
            '</ul>'
        },
        {
          question: 'Was sind RAID-Systeme?',
          answer:
            '<ul>' +
            '  <li>RAID = <strong>R</strong>edundant <strong>A</strong>rray of <strong>I</strong>ndependent <strong>D</strong>isks</li>' +
            '  <li>In unterschiedliche Levels unterteilt</li>' +
            '  <li>Daten werden je nach Raid Level mehrfach beziehungsweise verteilt gespeichert</li>' +
            '  <li>Software- oder Hardwaremäßig realisierbar</li>' +
            '  <li>Soll bei einem Hard- oder Software Ausfall vor Datenverlust schützen</li>' +
            '  <li>Auch eingesetzt um Hochverfügbarkeit zu erreichen (Festplatte A fällt aus -> Festplatte B übernimmt)</li>' +
            '</ul>'
        },
        {
          question: 'Welche RAID Level gibt es?',
          answer:
            '<ul>' +
            '  <li><strong>RAID 0</strong></li>' +
            '  <ul>' +
            '    <li>Verteilte Speicherung auf mehreren Datenträgern</li>' +
            '    <li>Bei Ausfall Teilverlust der Daten</li>' +
            '  </ul>' +
            '  <li><strong>RAID 1</strong></li>' +
            '  <ul>' +
            '    <li>Daten werden immer auf mindestens zwei Datenträgern gespeichert</li>' +
            '    <li>Bei Ausfall eines Datenträgers sind die Daten noch auf einem weiteren verfügbar</li>' +
            '  </ul>' +
            '  <li><strong>RAID 2</strong></li>' +
            '  <ul>' +
            '    <li>Sorry, Beschreibung ist noch in Arbeit 😖</li>' +
            '  </ul>' +
            '  <li><strong>RAID 3</strong></li>' +
            '  <ul>' +
            '    <li>Sorry, Beschreibung ist noch in Arbeit 😖</li>' +
            '  </ul>' +
            '  <li><strong>RAID 4</strong></li>' +
            '  <ul>' +
            '    <li>Sorry, Beschreibung ist noch in Arbeit 😖</li>' +
            '  </ul>' +
            '  <li><strong>RAID 5</strong></li>' +
            '  <ul>' +
            '    <li>Setzt mehrere Datenträger ein</li>' +
            '    <li>Erstellt Prüfsummen von Datenblöcken und schreibt diese auf einen anderen Datenträger als die Daten selbst</li>' +
            '    <li>Prüfsummen und Daten werden auf allen Datenträgern gleichverteilt&nbsp;</li>' +
            '    <li>Bei Ausfall eines Datenträgers können die Daten aus den Prüfsummen rekonstruiert werden</li>' +
            '  </ul>' +
            '  <li><strong>RAID 6</strong></li>' +
            '  <ul>' +
            '    <li>Sorry, Beschreibung ist noch in Arbeit 😖</li>' +
            '  </ul>' +
            '</ul>'
        },
        {
          question: 'Welche Datenspeicher gibt es?',
          answer:
            '<ul>' +
            '  <li>Optische Datenspeicher</li>' +
            '  <li>Elektronische Datenspeicher</li>' +
            '  <li>Magnetische Datenspeicher</li>' +
            '</ul>'
        },
        {
          question: 'Was sind optische Datenspeicher?',
          answer:
            '<ul>' +
            '  <li>Werden mittels optischer Abtastung (meist Laser) gelesen/beschrieben</li>' +
            '  <li>Beispiele</li>' +
            '  <ul>' +
            '    <li>CD (Compact Disc)</li>' +
            '    <li>DVD (Digital Video Disc)</li>' +
            '    <li>Blu-ray Disc</li>' +
            '  </ul>' +
            '  <li>Vorteile</li>' +
            '  <ul>' +
            '    <li>Geringe Abnutzung durch berührungsloses Lesen</li>' +
            '    <li>Geringe Medienkosten</li>' +
            '  </ul>' +
            '  <li>Nachteile</li>' +
            '  <ul>' +
            '    <li>Bei unsachgemäßer Lagerung kann es zu Datenverlust kommen</li>' +
            '    <li>Begrenzte Anzahl an Schreibzyklen bei wiederbeschreibbaren Medien</li>' +
            '  </ul>' +
            '</ul>'
        },
        {
          question: 'Was sind elektronische Datenspeicher?',
          answer:
            '<ul>' +
            '  <li>Halbleiterbauelemente werden in integrierten Schaltkreisen zusammengesetzt um Daten und Information zu speichern (Flash-Speicher)</li>' +
            '  <li>Begrenzte Anzahl an Schreibzyklen</li>' +
            '</ul>' +
            '<h3>USB Stick</h3>' +
            '<ul>' +
            '  <li>Universal Serial Bus</li>' +
            '</ul>' +
            '<h3>SSD</h3>' +
            '<ul>' +
            '  <li>Solid State Drive</li>' +
            '  <li>Einsatz wie Festplatte</li>' +
            '  <li>Keine beweglichen Teile</li>' +
            '  <li>Vorteile</li>' +
            '  <ul>' +
            '    <li>Hohe Transferraten</li>' +
            '    <li>Kurze Zugriffszeiten</li>' +
            '    <li>Niedrige Leistungsaufnahme</li>' +
            '    <li>Geräuschloser Betrieb</li>' +
            '  </ul>' +
            '  <li>Nachteile</li>' +
            '  <ul>' +
            '    <li>Hohe Kosten</li>' +
            '    <li>Fehler treten häufiger auf als in herkömmlichen Festplatten</li>' +
            '  </ul>' +
            '</ul>' +
            '<h3>Speicherkarten</h3>' +
            '<ul>' +
            '  <li>Wechselspeicher welche in mobilen Geräten eingesetzt werden</li>' +
            '  <li>Verschiedene Typen mit bis zu 64 GB</li>' +
            '  <li>Bekannteste Typen</li>' +
            '  <ul>' +
            '    <li>SD-Speicherkarten (Secure Digital Memory Card)</li>' +
            '    <li>CompactFlash</li>' +
            '  </ul>' +
            '</ul>' +
            '<h3>Was sind magnetische Datenspeicher?</h3>' +
            '<ul>' +
            '  <li>Festplatten</li>' +
            '  <li>Datenträger besteht aus magnetisierbaren Material</li>' +
            '  <li>Typischerweise rotiert oder bewegt sich das Speichermedium</li>' +
            '  <li>Empfindlich gegen Erschütterung</li>' +
            '</ul>' +
            '<h3>Was ist eine Datenspeicherung in der Cloud?</h3>' +
            '<ul>' +
            '  <li>Dienstleister stellt Datenspeicher über das Internet bereit</li>' +
            '  <li>Daten liegen beim Dienstleister</li>' +
            '  <li>Hardware steht in einem Rechenzentrum oder beim Dienstleister</li>' +
            '</ul>'
        }
      ]
    }
  }
}
</script>
